/* Trautis landing motion: reveal-on-scroll, parallax, count-up.
   DOM-safe (no innerHTML). Editor/no-JS safe: content is visible by default;
   we only opt into hidden-then-animate when we can also finish it.
   Respects prefers-reduced-motion. Pure helpers are exported for Node tests. */
(function (root) {
  'use strict';

  // --- Pure helpers (unit-tested) ---
  function clampProgress(scroll, start, end) {
    if (end <= start) return scroll >= end ? 1 : 0;
    var p = (scroll - start) / (end - start);
    return p < 0 ? 0 : p > 1 ? 1 : p;
  }
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
  function parallaxOffset(progress, distance) { return (progress - 0.5) * distance; }
  function countValue(progress, target, decimals) {
    var v = target * progress;
    return Number(v.toFixed(decimals || 0)).toString();
  }

  var api = { clampProgress: clampProgress, easeOutCubic: easeOutCubic, parallaxOffset: parallaxOffset, countValue: countValue };

  // --- DOM init (browser only) ---
  var doc = root && root.document;
  if (doc && typeof doc.querySelectorAll === 'function') {
    var reduce = false; // motion forced on per owner request (was prefers-reduced-motion check)

    function initReveals() {
      var els = doc.querySelectorAll('[data-reveal]');
      if (!els.length) return;
      doc.documentElement.classList.add('t-motion-ready');
      if (reduce || !('IntersectionObserver' in root)) {
        els.forEach(function (el) { el.classList.add('is-revealed'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
      els.forEach(function (el) { io.observe(el); });
    }

    function initParallax() {
      if (reduce) return;
      var els = doc.querySelectorAll('[data-parallax]');
      if (!els.length) return;
      var ticking = false;
      function update() {
        ticking = false;
        var vh = root.innerHeight || 0;
        els.forEach(function (el) {
          var host = el.closest('[data-parallax-host]') || el.parentElement || el;
          var r = host.getBoundingClientRect();
          // progress across viewport: 0 when host bottom enters bottom edge, 1 when host top leaves top edge
          var p = clampProgress(vh - r.top, 0, vh + r.height);
          var dist = Number(el.getAttribute('data-parallax-distance')) || 60;
          el.style.transform = 'translate3d(0,' + parallaxOffset(p, dist).toFixed(1) + 'px,0)';
        });
      }
      function onScroll() { if (!ticking) { ticking = true; root.requestAnimationFrame(update); } }
      root.addEventListener('scroll', onScroll, { passive: true });
      root.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    function initCountUps() {
      var els = doc.querySelectorAll('[data-countup]');
      if (!els.length) return;
      function run(el) {
        var target = Number(el.getAttribute('data-countup')) || 0;
        var decimals = Number(el.getAttribute('data-countup-decimals')) || 0;
        if (reduce || !('requestAnimationFrame' in root)) { el.textContent = countValue(1, target, decimals); return; }
        var dur = 1100, t0 = null;
        function frame(ts) {
          if (t0 === null) t0 = ts;
          var p = clampProgress(ts, t0, t0 + dur);
          el.textContent = countValue(easeOutCubic(p), target, decimals);
          if (p < 1) root.requestAnimationFrame(frame);
        }
        root.requestAnimationFrame(frame);
      }
      if (reduce || !('IntersectionObserver' in root)) { els.forEach(function (el) { run(el); }); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
      }, { threshold: 0.4 });
      els.forEach(function (el) { io.observe(el); });
    }

    var start = function () { initReveals(); initParallax(); initCountUps(); };
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
    else start();
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : this);
